export const NAVBAR_HEIGHT = "3rem";

export const SIDEBAR_WIDTH = "14rem";

export const CONTENT_FULL_WIDTH = `calc(100vw - ${SIDEBAR_WIDTH})`;

export const CONTENT_FULL_HEIGHT = `calc(100vh - ${NAVBAR_HEIGHT})`;

export const CONTENT_FULL_HEIGHT_PROPS = {
  height: `calc(100% - ${NAVBAR_HEIGHT})`,
  mt: NAVBAR_HEIGHT,
} as const;
